import {useDispatch} from 'react-redux'
import useCurrentUser from '../../hooks/useCurrentUser'
import css from './Recipes.module.css'
import {capitalize} from '../../util/util'
import {updateViewer,setCopy} from './recipesSlice'
import DiscussResourceButton from '../DiscussResourceButton/DiscussResourceButton'
import Button from 'react-bootstrap/Button'

import MacroTotals from './MacroTotals'

const Recipe = ({recipe})=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const isChain = user.account_type === 'chain'
	const setModalRecipe = ()=>{}
	const openViewer = ()=>{
		dispatch(updateViewer({
			show:true,
			id:recipe.id
		}))
	}

	return (
		<div onClick={openViewer}>
			<div className={css.Recipe}>
				{recipe.image && <img className={css.RecipeImg} src={recipe.image} loading="lazy" />}
				<div className={css.Body}>
					{recipe.name && <div className={css.RecipeName}>{recipe.name}</div>}
					{(recipe.owner_type !== user.account_type && !isClient) &&
						<div>
							<small className="text-muted d-block">
								{capitalize(recipe.owner_type)} recipe
							</small>
						</div>
					}
					<hr className="my-1 w-100"/>
					<MacroTotals recipe={recipe} align="left" />
					{recipe.tags?.length > 0 &&
						<>
							<hr className="my-1 w-100"/>
							<div>
								<small className="d-block">Tags:</small>
								<small className="d-block">
									{recipe.tags.map(({name}) => name).join(', ')}
								</small>
							</div>
						</>
					}
					{recipe.link && <div><a target="_blank" href={recipe.link}>link</a></div>}
					
					<div 
						onClick={e => { e.stopPropagation()}}
						className="text-right mt-auto"
					>
						<DiscussResourceButton
							className="btn btn-sm btn-outline-primary"
							name={recipe.name}
							id={recipe.id}
							type="recipe"
						>
							<i className="fa fa-comments"/> Discuss
						</DiscussResourceButton>
						{isChain &&
							<Button
								onClick={ e => {
									e.stopPropagation()
									dispatch(setCopy({
										show: true,
										id: recipe.id
									}))
								}}
								variant="outline-primary"
								size="sm"
							>
								Copy <i className="fa fa-copy" />
							</Button>
						}
					</div>
				</div>
			</div>
		</div>
	)
}


export default Recipe